module.exports = __webpack_public_path__ + "static/img/product04-6.04eb819f.png";